module.exports = __webpack_public_path__ + "img/person.2b570a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/person.png
// module id = +fsZ
// module chunks = 2 3 6 8 196